import * as React from "react";
import { Helmet } from "react-helmet";

import personSchema from "../data/personSchema";
import projects from "../projects";

const SITE_TITLE = "Ján Ďuraš (Jan Duras) — Site moved to janduras.com";
const SITE_ORIGIN = "https://jan.duras.me";
const NEW_SITE_URL = "https://janduras.com/";
const DESCRIPTION =
  "Ján Ďuraš (Jan Duras) has moved to a new website. Visit janduras.com to access the latest official website of Jan Duras.";
const OG_DESCRIPTION =
  "Visit janduras.com to access the latest official website of Jan Duras.";

const getProjectFromLocation = (pathname, search) => {
  const normalizedPath = pathname.replace(/\/$/, "");
  if (normalizedPath !== "/project") {
    return null;
  }

  const projectKey = new URLSearchParams(search).get("name");
  if (!projectKey) {
    return null;
  }

  return projects.find((project) => project.key === projectKey) ?? null;
};

const OldSiteHead = ({ location }) => {
  const { pathname, search } = location;
  const project = getProjectFromLocation(pathname, search);
  const title = project ? `${project.name} | ${SITE_TITLE}` : SITE_TITLE;
  const pageUrl = `${SITE_ORIGIN}${pathname}${search}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={DESCRIPTION} />
      <link rel="canonical" href={NEW_SITE_URL} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={OG_DESCRIPTION} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
    </Helmet>
  );
};

export default OldSiteHead;
